import { ReebeloStoreT } from '@lambda/reebelo';
import { PriceComponentsT } from '../catalog-v2/types';

// Cart related types
export enum LineItemType {
  PRODUCT = 'product',
  SHIPPING = 'shipping',
  WARRANTY = 'warranty',
}
export enum CartLineReferenceType {
  CART_LINE = 'cart_line',
  ORDER_LINE = 'order_line',
}
export enum CartStatus {
  OPEN = 'open',
  CLOSED = 'closed',
  ABANDONED = 'abandoned',
}

export enum Currency {
  USD = 'USD',
  CAD = 'CAD',
  SGD = 'SGD',
  AUD = 'AUD',
  NZD = 'NZD',
}

export type AmountT = {
  currency: Currency;
  subTotal: number;
  taxTotal: number;
  dutiesTotal: number;
  discountTotal: number;
  shippingTotal: number;
  grandTotal: number;
};

export type CartCustomerT = {
  customerId?: string;
  email?: string;
};

export type NoteT = {
  name: string;
  value: string;
};

export type CartLineCategoryT = {
  name: string;
  pk: string;
};

export type CartLineVariantT = {
  name: string;
  value: string;
};

export type CartLineReferenceT = {
  type: CartLineReferenceType;
  typeId: string;
};

export type CartLineT = {
  id: string; //
  type: LineItemType;
  typeId: string;
  title: string;
  handle?: string;
  image?: string;
  vendor: string;

  category?: CartLineCategoryT;
  variants?: CartLineVariantT[];
  sku: string;
  psku?: string;
  make?: string;
  model?: string;

  quantity: number;
  price: number;
  compareAtPrice?: number;
  subTotal: number;

  stock?: number;
  priceComponents?: PriceComponentsT[];
  reference?: CartLineReferenceT;
  notes?: NoteT[];
};

export type CartT = {
  id: string;
  store: ReebeloStoreT;
  createdAt: string;
  updatedAt: string;
  status: CartStatus;
  amount: AmountT;
  customer?: CartCustomerT;
  notes?: NoteT[];
  lines: CartLineT[];
};

// Other types
export type CreateCartDataT = {
  store: ReebeloStoreT;
  customerId?: string;
  lines?: CartLineT[];
  notes?: NoteT[];
};

export type ConvertShopifyCartT = {
  store: ReebeloStoreT;
  cartId: string;
};

export type CreateLineItemDataT = {
  type: LineItemType;
  typeId: string; // reebeloPk
  reference?: CartLineReferenceT;
  quantity?: number;
  notes?: NoteT[];
};

export type UpdateLineItemDataT = { quantity: number; notes?: NoteT[] };

export type CreateLineItemsDataT = { lines: CreateLineItemDataT[] };

export type UpdateLineItemsDataT = {
  lines: ({ id: string } & UpdateLineItemDataT)[];
};

export type DeleteLineItemsDataT = { lineIds: string[] };

export type RevalidatedLineT = {
  id: string;
  removed: boolean;
  priceChanged: boolean;
  stockChanged: boolean;
  vendorChanged: boolean;
  oldPrice: number;
  newPrice: number;
  oldStock?: number;
  newStock?: number;
  oldVendor?: string;
  newVendor?: string;
};

export type RevalidateCartResponseT = {
  cart: CartT;
  deltas: RevalidatedLineT[];
};
